<template>
  <div class="header">
    <div class="main">
      <h1 class="inline" @click="goHome">
        <img src="../../assets/logo.png" alt="" />
      </h1>
      <nav class="fright">
        <div>
          <div
            v-for="(item, idx) in navList"
            :key="idx"
            class="fleft nav"
            :class="{ active: activeIndex === idx }"
            @click.stop="handleNavClick(item, idx)"
            @mouseover="handleNavHover(item, idx)"
          >
            <h2>{{ item.name }}</h2>
            <transition name="bounce">
              <div
                v-if="showSubNav && hoveredIndex === idx && item.children && item.children.length && !item.isProduct"
                class="subNav"
                @mouseleave="closeSubNav"
              >
                <div
                  v-for="(child, childIdx) in item.children"
                  :key="childIdx"
                  :class="{ active: activeSubIndex === childIdx }"
                  @click.stop="goSubPage(child)"
                  @mouseenter="activeSubIndex = childIdx"
                >
                  {{ child.name }}
                  <span></span>
                </div>
              </div>
            </transition>
          </div>
          <div class="fleft nav">
            <el-dropdown @command="switchLang">
              <span class="el-dropdown-link">
                {{ currentLang === 'zh' ? '中文' : 'English' }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="zh">中文</el-dropdown-item>
                <el-dropdown-item command="en">English</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </nav>
    </div>

    <el-dialog
      class="isProduct_wrap"
      :modal="false"
      custom-class="custom-dialog"
      :visible.sync="dialogVisible"
      width="1200px"
      append-to-body
      :show-close="false"
    >
      <el-container
        class="isProduct"
        :class="[
          currentProduct.children && currentProduct.children.length
            ? 'shadow'
            : 'onlyBar',
          { 'lang-en': currentLang === 'en' },
        ]"
      >
        <el-aside width="160px" style="background-color: #ededed">
          <ul>
            <li
              v-for="(cat, idx) in productCategories"
              :key="idx"
              :class="{ bg: activeCategoryIndex === idx }"
              @click="selectProductCategory(cat, idx)"
            >
              {{ cat.name }}
              <span v-if="cat.childrens && cat.childrens.length" class="el-icon-arrow-right"></span>
            </li>
          </ul>
        </el-aside>
        <el-main v-if="currentProduct.childrens && currentProduct.childrens.length" style="background-color: #fff">
          <h3 class="typeName" @click="goProductDetail(currentProduct.id, -1)">
            {{ currentProduct.name }}
          </h3>
          <hr />
          <div
            v-for="(group, gIdx) in currentProduct.childrens"
            :key="gIdx"
            class="threeType"
          >
            <h4
              class="typeLastName"
              :class="{ active: activeTypeIndex === gIdx }"
              @click="goProductDetail(group.id, gIdx)"
            >
              {{ group.name }}
            </h4>
            <div v-for="(sub, sIdx) in group.childrens" :key="sIdx">
              <p @click="goProductDetail(sub.id, sIdx)">
                {{ sub.name }} <span class="el-icon-arrow-right"></span>
              </p>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-dialog>

    <el-dropdown class="rightMenu1" @command="switchLang">
      <span class="el-dropdown-link">
        {{ currentLang === 'zh' ? '中文' : 'English' }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="zh">中文</el-dropdown-item>
        <el-dropdown-item command="en">English</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div class="rightMenu" @click="drawer = true">
      <span><i></i></span>
    </div>
    <el-drawer size="200px" :append-to-body="true" :visible.sync="drawer" direction="rtl">
      <div class="menu">
        <div v-for="(item, idx) in navList" :key="idx" @click="goPath(item)">
          {{ item.name }}
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getProductTree,
  applyDomainList,
  getDictList,
  getProductList,
  getProductDetail,
  getApplyDetail,
  getNewsDetail,
} from '../../api/index';

export default {
  name: 'AppHeader',
  data() {
    return {
      activeIndex: 0,
      activeSubIndex: -1,
      hoveredIndex: -1,
      showSubNav: false,
      drawer: false,
      dialogVisible: false,
      productCategories: [],
      currentProduct: { childrens: [] },
      activeCategoryIndex: 0,
      activeTypeIndex: -1,
      productChildren: [],
      applyChildren: [],
      zlykkxChildren: [],
    };
  },
  computed: {
    currentLang() {
      if (this.$i18nState) return this.$i18nState.locale;
      if (this.$i18n) return this.$i18n.locale;
      return 'zh';
    },
    navList() {
      const baseZh = [
        { name: this.$t('home'), path: '/home', isProduct: false },
        { name: this.$t('product'), path: '/product/index', children: this.productChildren, isProduct: true },
        { name: this.$t('apply'), path: '/apply', children: this.applyChildren, isProduct: false },
        { name: this.$t('zlykkx'), path: '/zlykkx/zlgl', children: this.zlykkxChildren, isProduct: false },
        { name: this.$t('support'), path: '/fwzc/onlineClass', children: [
            { name: this.$t('onlineClass'), path: '/fwzc/onlineClass' },
            { name: this.$t('tecArticles'), path: '/fwzc/tecArticles' }
          ], isProduct: false },
        { name: this.$t('aboutUs'), path: '/about', children: [
            { name: this.$t('introduce'), path: '/about' },
            { name: this.$t('news'), path: '/news' },
            { name: this.$t('contact'), path: '/introduce' },
            { name: this.$t('xsydls'), path: '/fwzc/xsydls' }
          ], isProduct: false },
        { name: this.$t('joinUs'), path: '/joinUs', isProduct: false },
      ];
      const baseEn = [
        { name: this.$t('home'), path: '/home', isProduct: false },
        { name: this.$t('product'), path: '/product/index', children: this.productChildren, isProduct: true },
        { name: this.$t('apply'), path: '/apply', children: this.applyChildren, isProduct: false },
        { name: this.$t('zlykkx'), path: '/zlykkx/zlgl', children: this.zlykkxChildren, isProduct: false },
        { name: this.$t('aboutUs'), path: '/about', isProduct: false },
      ];
      return baseZh;
    },
    defaultProductId() {
      return this.currentLang === 'zh' ? 12 : 39;
    },
  },
  watch: {
    $route: {
      handler() {
        this.drawer = false;
        this.updateActiveNav();
      },
      immediate: true,
    },
    currentLang() {
      this.loadMenuData();
    },
  },
  mounted() {
    this.loadMenuData();
  },
  methods: {
    async loadMenuData() {
      const langCode = this.currentLang === 'zh' ? 'zh-CN' : 'en-US';
      const params = { languageCode: langCode };
      try {
        const [productRes, applyRes, dictRes] = await Promise.all([
          getProductTree(params),
          applyDomainList(params),
          getDictList('cms_quality_reliability'),
        ]);
        this.productChildren = productRes.data || [];
        this.applyChildren = (applyRes.rows || []).map(item => ({
          ...item,
          path: '/apply',
        }));
        this.zlykkxChildren = (dictRes.data || []).map(item => ({
          dictValue: item.dictValue,
          dictLabel: item.dictLabel,
          dictLabelEn: item.dictLabelEn,
          path: `/zlykkx/zlgl?id=${item.dictValue}`,
          name: this.currentLang === 'zh' ? item.dictLabel : item.dictLabelEn,
        }));
        if (this.productChildren.length) {
          this.productCategories = this.productChildren;
          this.currentProduct = this.productChildren[0];
        }
      } catch (error) {
        console.error('加载菜单数据失败：', error);
      }
    },
    async switchLang(lang) {
      if (lang === this.currentLang) return;
      const currentPath = this.$route.path;
      const currentQuery = { ...this.$route.query };
      if (this.$i18nState) this.$i18nState.locale = lang;
      if (this.$i18n) this.$i18n.locale = lang;
      const replaceLangInPath = (path, newLang) => {
        if (/\/(zh|en)$/.test(path)) {
          return path.replace(/\/(zh|en)$/, `/${newLang}`);
        }
        return path + (path.endsWith('/') ? newLang : `/${newLang}`);
      };
      // 特殊路径处理映射
      const handlers = {
        '/product/index': async () => {
          const newPath = replaceLangInPath(currentPath, lang);
          this.$router.replace({ path: newPath, query: { id: this.defaultProductId } });
        },
        '/product/productDetail': async () => {
          const productId = currentQuery.id;
          if (!productId) {
            this.$router.replace({ path: replaceLangInPath('/product/index', lang), query: { id: this.defaultProductId } });
            return;
          }
          try {
            const { data: product } = await getProductDetail(productId);
            const { rows } = await getProductList({
              name: product.name,
              displayStatus: 1,
              languageCode: lang === 'zh' ? 'zh-CN' : 'en-US',
            }, { pageNum: 1, pageSize: 1 });
            const newId = rows && rows.length ? rows[0].id : this.defaultProductId;
            this.$router.replace({ path: replaceLangInPath(currentPath, lang), query: { id: newId } });
          } catch (err) {
            console.error('产品详情切换语言失败', err);
            this.$router.replace({ path: replaceLangInPath('/product/index', lang), query: { id: this.defaultProductId } });
          }
        },
        '/apply/ApplyDetail': async () => {
          const applyId = currentQuery.id;
          if (!applyId) return;
          try {
            const { data } = await getApplyDetail(applyId, { id: applyId, languageCode: lang === 'zh' ? 'zh-CN' : 'en-US' });
            this.$router.replace({ path: replaceLangInPath(currentPath, lang), query: { id: data.id } });
          } catch (err) {
            console.error('应用详情切换语言失败', err);
          }
        },
        '/newsDetail': async () => {
          const newsId = currentQuery.id;
          if (!newsId) return;
          try {
            const { data } = await getNewsDetail(newsId, { id: newsId, languageCode: lang === 'zh' ? 'zh-CN' : 'en-US' });
            this.$router.replace({ path: replaceLangInPath(currentPath, lang), query: { id: data.id } });
          } catch (err) {
            console.error('新闻详情切换语言失败', err);
          }
        },
      };
      let handled = false;
      for (const pattern in handlers) {
        if (currentPath.includes(pattern)) {
          await handlers[pattern]();
          handled = true;
          break;
        }
      }
      if (!handled) {
        const newPath = replaceLangInPath(currentPath, lang);
        this.$router.replace({ path: newPath, query: currentQuery });
      }
    },
    getLocalizedPath(rawPath) {
      const lang = this.currentLang;
      if (/\/(zh|en)$/.test(rawPath)) return rawPath;
      const base = rawPath.endsWith('/') ? rawPath.slice(0, -1) : rawPath;
      return base + '/' + lang;
    },
    goHome() {
      this.$router.push(this.getLocalizedPath('/home'));
    },
    goPath(item) {
      const targetPath = this.getLocalizedPath(item.path);
      if (item.path === '/product/index') {
        this.$router.replace({ path: targetPath, query: { id: this.defaultProductId } });
        this.activeCategoryIndex = 0;
        this.currentProduct = this.productCategories[0];
      } else {
        this.$router.push(targetPath);
        window.scrollTo(0, 0);
      }
    },
    goSubPage(child) {
      if (!child.path) return;
      const [basePath, queryString] = child.path.split('?');
      const query = {};
      if (queryString) {
        queryString.split('&').forEach(pair => {
          const [key, val] = pair.split('=');
          if (key) query[key] = decodeURIComponent(val || '');
        });
      }
      const fullPath = this.getLocalizedPath(basePath);
      if (child.path === '/product/index' || child.path === '/apply') {
        this.$router.push({ path: fullPath, query: { id: child.id } });
      } else if (Object.keys(query).length) {
        this.$router.push({ path: fullPath, query });
      } else {
        this.$router.push(fullPath);
      }
      window.scrollTo(0, 0);
      this.closeSubNav();
    },
    selectProductCategory(cat, idx) {
      this.currentProduct = cat;
      this.activeCategoryIndex = idx;
      this.activeTypeIndex = -1;
      this.$router.replace({ path: this.getLocalizedPath('/product/index'), query: { id: cat.id } });
      if (!cat.childrens || !cat.childrens.length) this.dialogVisible = false;
    },
    goProductDetail(productId, typeIndex) {
      this.activeTypeIndex = typeIndex;
      this.$router.push({ path: this.getLocalizedPath('/product/index'), query: { id: productId } });
      this.dialogVisible = false;
      window.scrollTo(0, 0);
    },
    handleNavHover(item, idx) {
      this.hoveredIndex = idx;
      this.showSubNav = true;
      this.activeSubIndex = -1;
      if (item.isProduct && idx === 1) {
        this.dialogVisible = true;
        if (this.productCategories.length) {
          this.currentProduct = this.productCategories[this.activeCategoryIndex] || { childrens: [] };
        }
      } else {
        this.dialogVisible = false;
      }
    },
    handleNavClick(item, idx) {
      this.activeIndex = idx;
      this.goPath(item);
    },
    closeSubNav() {
      this.showSubNav = false;
      this.hoveredIndex = -1;
    },
    updateActiveNav() {
      const currentPath = this.$route.path.replace(/\/(zh|en)$/, '');
      const idx = this.navList.findIndex(item => item.path === currentPath);
      // this.activeIndex = idx !== -1 ? idx : 0;
    },
  },
};
</script>

<style scoped lang="scss">
/* 响应式断点合并 */
.main {
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  box-sizing: border-box;
}

@media (min-width: 300px) {
  .main {
    width: 300px;
  }
  nav {
    display: none;
  }
  .rightMenu {
    display: block;
  }
  .rightMenu1 {
    display: block;
  }
}
@media (min-width: 600px) {
  .main {
    width: 600px;
  }
  nav {
    display: none;
  }
  .rightMenu {
    display: block;
  }
  .rightMenu1 {
    display: block;
  }
}
@media (min-width: 700px) {
  .main {
    width: 700px;
  }
  nav {
    display: none;
  }
  .rightMenu {
    display: block;
  }
  .rightMenu1 {
    display: block;
  }
}
@media (min-width: 800px) {
  .main {
    width: 800px;
  }
  nav {
    display: none;
  }
  .rightMenu {
    display: block;
  }
  .rightMenu1 {
    display: block;
  }
}
@media (min-width: 1000px) {
  .main {
    width: 1000px;
  }
  nav {
    display: none;
  }
  .rightMenu {
    display: block;
  }
  .rightMenu1 {
    display: block;
  }
}
@media (min-width: 1100px) {
  .main {
    width: 1100px;
  }
  nav {
    display: none;
  }
  .rightMenu {
    display: block;
  }
  .rightMenu1 {
    display: block;
  }
}
@media (min-width: 1200px) {
  .main {
    width: 1200px;
  }
  nav {
    display: block;
  }
  .rightMenu {
    display: none;
  }
  .rightMenu1 {
    display: none;
  }
}

.header {
  position: fixed;
  width: 100%;
  background-color: rgba(#13458f, 0.8);
  color: #fff;
  z-index: 2002;
  img {
    height: 60px;
    margin-top: 10px;
  }
}

.nav {
  position: relative;
  cursor: pointer;
  text-align: center;
  padding: 18px 24px;
  h2 {
    font-size: 18px;
    line-height: 44px;
  }
  &.active h2 {
    color: #cf2b5d;
    font-weight: bolder;
  }
  &:hover .subNav {
    display: block;
  }
}
.lang-en .nav {
  padding: 18px 12px;
}

.subNav {
  display: none;
  position: absolute;
  background: #fff;
  color: #1e1e1e;
  width: 160px;
  z-index: 999;
  padding: 0 10px 10px;
  top: 78px;
  left: 50%;
  margin-left: -80px;
  div {
    line-height: 40px;
    margin-top: 10px;
    cursor: pointer;
    &:hover {
      color: #cf2b5d;
    }
    &.active span {
      display: block;
      width: 24px;
      height: 3px;
      background-color: #cf2b5d;
      margin: 0 auto;
    }
    span {
      display: none;
      height: 3px;
    }
  }
}
.bounce-enter-active,
.bounce-leave-active {
  transition: opacity 0.2s;
}
.bounce-enter,
.bounce-leave-to {
  opacity: 0;
}
.rightMenu1 {
  width: 80px;
  height: 44px;
  position: absolute;
  right: 50px;
  top: 10px;
}
.rightMenu {
  width: 22px;
  height: 44px;
  position: absolute;
  right: 20px;
  top: 10px;
  cursor: pointer;
  span {
    display: block;
    width: 22px;
    height: 2px;
    background-color: rgba(255, 255, 255, 0.8);
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    &::before,
    &::after {
      content: "";
      display: block;
      width: 22px;
      height: 2px;
      background-color: rgba(255, 255, 255, 0.8);
      position: absolute;
      transition: all 0.3s;
    }
    &::before {
      bottom: 8px;
    }
    &::after {
      top: 8px;
    }
  }
}

.menu {
  background-color: #fff;
  > div {
    text-align: center;
    line-height: 50px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
}

/* 产品弹窗样式 */
.isProduct {
  position: absolute;
  right: 10px;
  color: #1e1e1e;
  text-align: left;
  li {
    line-height: 40px;
    font-size: 14px;
    padding: 4px 20px;
    cursor: pointer;
    span {
      float: right;
      color: #231815;
      line-height: 40px;
    }
    &:hover,
    &.bg {
      background-color: #0b3576;
      color: #fff;
      span {
        color: #fff;
      }
    }
  }
  .typeName {
    color: #555;
    font-size: 14px;
    text-indent: 14px;
    cursor: pointer;
  }
  .typeLastName {
    background-color: #ededed;
    height: 45px;
    line-height: 45px;
    text-indent: 10px;
    margin-bottom: 10px;
    font-size: 13px;
    cursor: pointer;
    &.active {
      color: #fff;
      background-color: #0b3576;
    }
  }
  .threeType {
    float: left;
    width: 50%;
    padding: 4px;
    box-sizing: border-box;
    > div p {
      line-height: 40px;
      color: #1e1e1e;
      border-bottom: 1px solid #e2e2e2;
      font-size: 14px;
      text-indent: 10px;
      cursor: pointer;
      span {
        float: right;
        margin-right: 6px;
        line-height: 40px;
      }
    }
  }
}
.shadow {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.onlyBar {
  width: 850px;
}
.isProduct {
  // ... 原有样式保持不变

  // 英文环境下的样式覆盖
  &.lang-en {
    // width: 640px; // 适当加宽
    // right: 0;                // 调整右偏移（可选）
    // 如果使用 onlyBar 时需要调整位置
    &.onlyBar {
      // right: 760px;          // 对应加宽后的偏移量
    }
  }
}
.el-dropdown-link {
  color: #fff;
  line-height: 42px;
}
.el-dropdown-menu {
  z-index: 3000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue